
import { Client } from "@/models/Client";

export const getRemainingSessionsCount = (client: Client): number => {
  const remaining = client.subscriptions
    .filter(sub => sub.isActive)
    .reduce((total, sub) => {
      const remainingForSub = sub.sessionsPerMonth - sub.currentCycleSessionsUsed;
      console.log(`Client ${client.firstName} ${client.lastName} - Subscription ${sub.workoutTypeId}:`, {
        sessionsPerMonth: sub.sessionsPerMonth,
        currentCycleSessionsUsed: sub.currentCycleSessionsUsed,
        remainingForSub: remainingForSub
      });
      return total + remainingForSub;
    }, 0);
  
  console.log(`Total remaining sessions for ${client.firstName} ${client.lastName}:`, remaining);
  return remaining;
};

export const hasSoonExpiringSessions = (client: Client): boolean => {
  const activeSubscriptions = client.subscriptions.filter(sub => sub.isActive);
  
  // Check if ANY subscription has 1 or fewer sessions remaining (consistent with database logic)
  const hasSoonExpiring = activeSubscriptions.some(sub => {
    const remainingForSub = sub.sessionsPerMonth - sub.currentCycleSessionsUsed;
    const isSoonExpiringForSub = remainingForSub <= 1;
    
    console.log(`Client ${client.firstName} ${client.lastName} - Subscription ${sub.workoutTypeId} check:`, {
      sessionsPerMonth: sub.sessionsPerMonth,
      currentCycleSessionsUsed: sub.currentCycleSessionsUsed,
      remainingForSub: remainingForSub,
      isSoonExpiringForSub: isSoonExpiringForSub
    });
    
    return isSoonExpiringForSub;
  });
  
  console.log(`Client ${client.firstName} ${client.lastName} - Soon expiring result:`, hasSoonExpiring);
  return hasSoonExpiring;
};

export const hasLowSessions = (client: Client): boolean => {
  // Check if ANY active subscription has consumed all or all-but-one sessions
  // This matches the cycle-based logic: current_cycle_sessions_used >= (sessions_per_month - 1)
  return client.subscriptions.some(sub => {
    if (!sub.isActive) return false;
    return sub.currentCycleSessionsUsed >= (sub.sessionsPerMonth - 1);
  });
};

// Function to check if client has unpaid sessions based on payment status
export const hasUnpaidSessions = (client: Client): boolean => {
  return client.paymentStatus === 'unpaid' || client.paymentStatus === 'partial';
};

// Function to get payment status display info
export const getPaymentStatusInfo = (client: Client) => {
  const status = client.paymentStatus || 'unpaid';
  
  switch (status) {
    case 'paid':
      return {
        label: 'Paid',
        variant: 'default' as const,
        bgColor: 'bg-green-50',
        textColor: 'text-green-700',
        borderColor: 'border-green-200'
      };
    case 'partial':
      return {
        label: 'Partial',
        variant: 'outline' as const,
        bgColor: 'bg-yellow-50',
        textColor: 'text-yellow-700',
        borderColor: 'border-yellow-200'
      };
    case 'unpaid':
      return {
        label: 'Unpaid',
        variant: 'destructive' as const,
        bgColor: 'bg-red-50',
        textColor: 'text-red-700',
        borderColor: 'border-red-200'
      };
    default:
      return {
        label: 'Unknown',
        variant: 'outline' as const,
        bgColor: 'bg-gray-50',
        textColor: 'text-gray-700',
        borderColor: 'border-gray-200'
      };
  }
};
